import {Component, OnInit} from '@angular/core';
import {BlockService, PageService} from '@gallaghercp/core-frontend';
import {NavigationEnd, Router} from '@angular/router';
import {BlockHeroHeaderComponent} from '../../blocks/block-hero-header/block-hero-header.component';
import {BlockValueStatementComponent} from '../../blocks/block-value-statement/block-value-statement.component';
import {BlockCompanyPromiseComponent} from '../../blocks/block-company-promise/block-company-promise.component';
import {BlockTimeRewardsComponent} from '../../blocks/block-time-rewards/block-time-rewards.component';
import {BlockFinancialRewardsComponent} from '../../blocks/block-financial-rewards/block-financial-rewards.component';
import {BlockAddedExtrasComponent} from '../../blocks/block-added-extras/block-added-extras.component';
import {BlockMaximiseRewardsComponent} from '../../blocks/block-maximise-rewards/block-maximise-rewards.component';
import {
    BlockOtherValuableBenefitsComponent
} from '@core-app/blocks/block-other-valuable-benefits/block-other-valuable-benefits.component';
import {
    BlockTotalRewardsSummaryComponent
} from '@core-app/blocks/block-total-rewards-summary/block-total-rewards-summary.component';
import {TrsService} from '@core-app/services/trs.service';

@Component({
    selector: 'core-main',
    templateUrl: './main.component.html',
    standalone: false
})

export class MainComponent implements OnInit {

    containerClass!: string;
    page: any;
    category!: string | boolean;
    delayedLoaded!: boolean;
    isPrintPDFRoute: boolean = false;

    constructor(
        private router: Router,
        private blocks: BlockService,
        private trsService: TrsService,
        private pages: PageService
    ) {
    }

    private setContainerClass() {
        switch (this.router.url) {
            case '/':
            case '/1':
            case '/#maincontent':
            case '/default':
                this.containerClass = 'container-fluid home-container';
                this.turnPDFPrintOff();
                break;
            case '/print':
                this.turnPDFPrintOn();
                break;
            default:
                this.containerClass = 'container';
                this.turnPDFPrintOff();
                break;
        }
    }

    ngOnInit(): void {
        this.setContainerClass();
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.setContainerClass();
            }
        });

        this.pages.currentPage$!.subscribe(page => {
            this.delayedLoaded = false;
            if (page) {
                this.page = page;
                this.category = this.page.categoryNames && this.page.categoryNames[0]
                    ? this.page.categoryNames[0].toLowerCase().replace(' ', '-')
                    : false;
            }
            setTimeout(() => {
                this.delayedLoaded = true;
            }, 300);
        });

        this.blocks.addBlock('HERO-HEADER', BlockHeroHeaderComponent);
        this.blocks.addBlock('VALUE-STATEMENT', BlockValueStatementComponent);
        this.blocks.addBlock('COMPANY-PROMISE', BlockCompanyPromiseComponent);
        this.blocks.addBlock('FINANCIAL-REWARDS', BlockFinancialRewardsComponent);
        this.blocks.addBlock('TIME-REWARDS', BlockTimeRewardsComponent);
        this.blocks.addBlock('ADDED-EXTRAS', BlockAddedExtrasComponent);
        this.blocks.addBlock('MAXIMISE-REWARDS', BlockMaximiseRewardsComponent);
        this.blocks.addBlock('OTHER-VALUABLE-BENEFITS', BlockOtherValuableBenefitsComponent);
        this.blocks.addBlock('TOTAL-REWARDS-SUMMARY', BlockTotalRewardsSummaryComponent);

        this.isPrintPDFRoute = this.trsService.isPrintRoute();
    }

    turnPDFPrintOff() {
        // const body = document.body;
        // body.classList.remove('print-pdf-on');
        const printStyle = document.getElementById('print-style-id');
        if (printStyle != null) {
            document.getElementsByTagName('head')[0].removeChild(printStyle);
        }
        // body.classList.add('print-pdf-off');
    }

    turnPDFPrintOn() {
        const body = document.body;
        const printStyle = document.createElement('style');
        printStyle.type = 'text/css';
        printStyle.id = 'print-style-id';
        printStyle.innerHTML = '@page {\n' +
            '  size: A5 landscape !important;\n' +
            '}\n' +
            ' body > :last-child: { margin-bottom: -1px; overflow: hidden; }\n' +
            ' body { margin: 0; }\n';
        document.getElementsByTagName('head')[0].appendChild(printStyle);
        body.classList.remove('print-pdf-off');
        body.classList.add('print-pdf-on');
    }

}
